/* istanbul ignore file: this file is mostly jQuery */
'use strict';

customerZone

/**
 * A picker for cities.  This needs to be linked to two input fields; one for postcode and one for city, and will
 * provide a single autocomplete for both.
 *
 * @param List cities: a list of format [{postalCode, city}]
 * @param postcodeField: html-id of the input element for postcode
 * @param cityField: html-id of the input element for city
 */
.component('cityPicker', {
    bindings: {
        postcodeField: '@',
        cityField: '@'
    },
    templateUrl: customerZone.fromBase('components/citypicker/citypicker.component.html'),
    controller: ['$timeout', '$log', 'CityProvider', function($timeout, $log, CityProvider){
        var vm = this;

        var $postcodeField;
        var $cityField;

        var cities = [];

        CityProvider.getCities()
            .then(function(_cities_){
                cities = _cities_;
            })
            .catch(function(error){
                $log.error('Could not load cities', error);
            });

        vm.$postLink = function(){

            $postcodeField = $('#'+vm.postcodeField);
            $cityField = $('#'+vm.cityField);

            $postcodeField.add($cityField)
                .keyboardNavigation({
                    currentIdx: function() { return vm.selectedIdx; },
                    allowedRange: function() { return vm.filtered ? [0, vm.filtered.length-1] : undefined; },
                    select: function(idx) { $timeout(function(){ vm.select(idx); }); },
                    complete: function() { $timeout(function(){ vm.closePopup(); }); },
                    type: function($field) {
                        $timeout(function(){
                            var filterValue = $field.val();
                            if (filterValue === '') vm.filtered = undefined;
                            else vm.filtered = filterByField($field, filterValue);
                        });
                    }
                });

            function filterByField($field, value){
                var isPostalCode = $field[0] === $postcodeField[0];
                var expression = new RegExp('\\b' + RegExp.escape(value.toLowerCase()));
                var key = isPostalCode ? 'postalCode' : 'city';
                var filtered = cities.filter(function(candidate){
                    return expression.test(candidate[key].toLowerCase());
                });

                // in case of a perfect match, fill both this field and the other one.
                if (isPostalCode && filtered.length && filtered[0].postalCode === value) {
                    set($cityField, filtered[0].city);
                    return filtered;
                }
                else if (!isPostalCode && filtered.length && filtered[0].city.toLowerCase() === value.toLowerCase()) {
                    set($postcodeField, filtered[0].postalCode);
                    return limit(filtered, 10);
                }
                else
                    return limit(filtered, 10);
            }

            function limit(list, count){
                if (list.length <= count) return list;
                return list.slice(0, count);
            }
        };

        vm.$onDestroy = function(){
            $postcodeField = $('#'+vm.postcodeField);
            $cityField = $('#'+vm.cityField);
            $postcodeField.add($cityField).keyboardNavigationRemove();
        };

        vm.select = function(idx){
            var selected = vm.filtered[idx] || {};
            vm.selectedIdx = idx;
            set($postcodeField, selected.postalCode);
            set($cityField, selected.city);
        };

        vm.closePopup = function(){
            vm.filtered = undefined;
            vm.selectedIdx = undefined;
        };

        var set = function($field, value){
            value = value || '';
            var selStart = $field[0].selectionStart;
            var prevValue = $field.val();
            $field.val(value);
            if (value.substr(0, selStart).toLowerCase() === prevValue.substr(0, selStart).toLowerCase())
                $field[0].selectionStart = selStart;
            else
                $field[0].selectionStart = 0;
            $field[0].selectionEnd = value.length;
            $field.triggerHandler('input');
            $field.triggerHandler('change');
        };

    }],
    controllerAs: 'vm'
});
